/**
 * Author：Qian.qianchen 2018-11-15 
 * discription: 产品管理 微博 微博账号排序
 */
'use strict';
angular.module('productManageMentSortWeiboModule', []).controller('productManageMentSortWeiboCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$validation',
    function($scope, $modalInstance, modalDialog, item, params, trsHttpService, $validation) {
        initStatus();

        /**
         * [initStatus description]
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.data = {
                userName: item.ACCOUNTNAME,
                indexNum: item.index,
                userId: item.ACCOUNTID
            };
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.sortForm.$pending = {};
            $validation.validate($scope.sortForm).success(function() {
                var params = angular.extend({
                    serviceid: 'wcm61_scmaccount',
                    methodname: 'resetAccountOrderToJson',
                    accountId: $scope.data.userId,
                    orderNumber: $scope.data.indexNum
                }, params);
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', params, 'post', true).then(function(data) {
                    $modalInstance.close('success');
                }, function(data) {
                    $modalInstance.close(data);
                });
            });
        };
    }
]);
